import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'sourcesTitle'
	| 'betaFeaturesMessage'
	| 'betaLozenge'
	| 'snapshotActionPlaceholder';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		sourcesTitle: {
			id: 'rovo-chat.store-assistant.sources-title',
			defaultMessage: 'Sources:',
			description:
				'Title text displayed above a list of sources in an AI assistant message within the AI conversation interface. Shown as a section heading or label. The purpose is to identify the sources section, which lists the references, documents, or data sources that the AI used to generate its response, helping users understand where the information came from.',
		},
		betaFeaturesMessage: {
			id: 'rovo-chat.store-assistant.beta-features-message',
			defaultMessage: 'The answer provided utilizes BETA features.',
			description:
				'Message text displayed in an AI assistant message within the AI conversation interface, indicating that the response was generated using beta (experimental) features. Shown as informational text, typically displayed alongside a BETA lozenge or badge. The purpose is to inform users that the answer may use experimental functionality that is still in testing and may have limitations or changes.',
		},
		betaLozenge: {
			id: 'rovo-chat.store-assistant.beta-lozenge',
			defaultMessage: 'BETA',
			description:
				'Label text displayed on a badge or lozenge in an AI assistant message within the AI conversation interface, indicating that beta (experimental) features were used to generate the response. Shown as text on a badge or lozenge component. The purpose is to visually identify that the response utilizes experimental functionality that is still in testing.',
		},
		snapshotActionPlaceholder: {
			id: 'rovo-chat.store-assistant.snapshot-action-placeholder',
			defaultMessage: 'Action unavailable in shared conversation',
			description:
				'Text displayed in place of an action when a message originates from a shared conversation snapshot. The action cannot be performed because it comes from a read-only snapshot. Informs the user that an action existed here but is not available in this context.',
		},
	});

export default message;
